module.exports = __webpack_public_path__ + "img/gui_shebao.6cb471de.png";